import * as React from 'react';
import {Alert, Box,Card,CardContent, LinearProgress, Table, TableCell, TableRow, TableBody} from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import MobileDial from 'views/Dashboard/shared/MobileDial';
import withLink from 'utils/withLink';
import EntitiesTable from 'views/Dashboard/shared/EntitiesTable/EntitiesTable'
import VideosFilters from './VideosFilters';
import { useNavigate } from 'react-router';
import parseDate from 'utils/parseDate';
import { hidden_md } from "views/Dashboard/shared/EntitiesTable/cell_visibility"
import { VideosActions } from './actions';
import { extractType } from '../utils';
import { PublicVideoUrl } from 'features/api_url';

const actions = [
  { icon: withLink("create",<FileCopyIcon />), name: 'Add new video' },

];

const columns = [
  {
    id: 'id',

    disablePadding: true,
    label: 'ID',
    hidden : hidden_md,
  },
  {
    id: 'title',
    disablePadding: false,
    label: 'Title',

  },
  {
    id: 'subtitle',
    disablePadding: false,
    label: 'Subtitle',
    hidden : hidden_md,
  },
  {
    id: 'videoable_type',
    disablePadding: false,
    label: 'Type',
    parseFunction: extractType
  },
  {
    id: 'created_at',

    disablePadding: false,
    label: 'Added on',
    hidden : hidden_md,
    parseFunction: parseDate
  }
];

const VideoDrawer = (props) => {

  const { row } = props;
  return (
    <>
    <Box sx={{ mt: 1,mb:1,display:'flex',columnGap:2,border:"1px solid #ddd", flexWrap:"wrap"}}>
        <Box sx={{ flexGrow:1,flexBasis:0, minwidth:"250px",width:{ "xs": "100%", "sm":"50%"}}}>
          <video width="100%" src={PublicVideoUrl + row.url} controls />
        </Box>
        <Box sx={{ flexGrow:1,flexBasis:0, width:{ "xs": "100%", "sm":"50%"}}}>
          <Table>
            <TableBody>
            <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>{row.title}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Subtitle</TableCell>
                <TableCell>{row.subititle}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>File location</TableCell>
                <TableCell>{row.url}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>{row.description}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>{extractType(row.videoable_type)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Created on</TableCell>
                <TableCell>{parseDate(row.created_at)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
      </Box>
    </Box>
  </>
  )

}
const VideosList = (props) => {

  const { items, withFilters, withDrawer, withActions, onPick } = props;
  const [filteredItems, setFilteredItems] = React.useState(items);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    console.log("FILTER LIST");
    setFilteredItems(items);
  },[items]);

  if(items.length === 0) return <LinearProgress />

  return (
    <>
      { withFilters && 
      <Box sx={{ width: '100%',mt: 3 }}>
        <Card>
          <CardContent>
             <VideosFilters
                items={items}
                onChange={setFilteredItems}
              />
          </CardContent>
        </Card>
      </Box>
      }
      { filteredItems.length === 0 ?
        (
          <Alert severity="warning">Nothing to show</Alert>
        ) : (

          <Box sx={{ width: '100%', mt:3,mb:5 }}>

            <Card>
            <CardContent>
                <EntitiesTable
                  entityName="videos"
                  items={filteredItems}
                  columns={columns}
                  rowActions={withActions ? VideosActions(dispatch, navigate, enqueueSnackbar) : false}
                  onPick={onPick}
                  withDrawer
                  renderDrawer={withDrawer ? <VideoDrawer /> : <></>}
                  orderColumn={'ex_date'}
                />
              </CardContent>
            </Card>
          </Box>
        )}
      <MobileDial actions={actions} />
    </>
  );
}

export default VideosList;